module.exports = __webpack_public_path__ + "static/img/report_img_xxxmabfa.eda3a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_xxxmabfa.png
// module id = 3iJW
// module chunks = 21